import { DiniArgeoWeighbridge } from "./DiniArgeoWeighbridge";
import { LD5204Weighbridge } from "./LD5204Weighbridge";
import { LineBreakTransformer } from "./LineBreakTransformer";
import { MX100Weighbridge } from "./MX100Weighbridge";
import {Diva11Weighbridge} from "./Diva11Weighbridge";

export type WeighbridgeCollection = {
    [key: string]: Weighbridge;
};

export interface ParsedWeightData {
    modes: any[];
    weight: number;
    unit: string;
}

export interface Weighbridge {
    baudRate: number;
    lineBreakSeparator: string;
    lineBreakTransformer?: LineBreakTransformer;
    parse: (input: string) => ParsedWeightData;
    getLineBreakTransformer: () => LineBreakTransformer;
}

const registeredWeighbridges: WeighbridgeCollection = {};

export const registerWeighbridge = (key: string, weighbridge: Weighbridge): Weighbridge | undefined => {
    if (key in registeredWeighbridges) {
        console.warn(`Weighbridge with key '${key}' is already registered`);
        return undefined;
    }
    
    registeredWeighbridges[key] = weighbridge;
    return weighbridge;
}

export const getWeighbridge = (key: string): Weighbridge | undefined => {
    if (key in registeredWeighbridges) {
        return registeredWeighbridges[key];
    }
    
    console.error(`Weighbridge with key '${key}' is not registered.`);
    return undefined;
}

// Register all weighbridge models below
// TODO: Maybe make it an enum as it is done on server
registerWeighbridge('dini-argeo', new DiniArgeoWeighbridge());
registerWeighbridge('ld5204', new LD5204Weighbridge());
registerWeighbridge('mx100', new MX100Weighbridge());
registerWeighbridge('diva11', new Diva11Weighbridge());